import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { InnerBlock } from "@/components/InnerBlock";
import { InnerCTA } from "@/components/InnerCTA";
import { PODCAST_INTRO, PODCAST_EPISODES } from "@/data/podcast";

export default function Podcast() {
  return (
    <div data-testid="podcast-index">
      <Seo title="The Wafa Podcast" description="Conversations with operators, engineers and buyers of software in Oman." />
      <PageHero
        eyebrow="Podcast"
        h1="The Wafa Podcast"
        intro={PODCAST_INTRO}
        breadcrumbs={[{ label: "Home", to: "/" }, { label: "Resources", to: "/resources" }, { label: "Podcast" }]}
      />

      <InnerBlock tint="white">
        <ol className="space-y-4">
          {PODCAST_EPISODES.map((ep) => (
            <li
              key={ep.slug}
              data-testid={`podcast-episode-${ep.slug}`}
              className="rounded-lg border border-wafa-deep/10 bg-white p-6 transition-shadow hover:shadow-[0_18px_40px_-20px_rgba(14,79,58,0.18)]"
            >
              <div className="flex flex-wrap items-start gap-4">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-wafa-cream font-heading text-lg font-semibold text-wafa-deep">
                  {String(ep.number).padStart(2, "0")}
                </div>
                <div className="flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded-full bg-wafa-sunshine px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-wafa-deep">
                      {ep.status}
                    </span>
                  </div>
                  <h2 className="mt-2 font-heading text-lg font-semibold text-wafa-deep sm:text-xl">
                    {ep.title}
                  </h2>
                  <p className="mt-2 text-sm text-wafa-ink/75 lg:text-base">{ep.summary}</p>
                </div>
              </div>
            </li>
          ))}
        </ol>
      </InnerBlock>

      <InnerCTA heading="Would you make a good guest?" body="If you have built, bought or run software in Oman and have something honest to say about it, we would love to have you on. Email support@wafa.om." />
    </div>
  );
}
